import React from 'react';
import moment from 'moment';
import { UncontrolledTooltip } from "reactstrap";
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';



class Editions extends React.Component {
    constructor(props) {
        super(props);

        this.renderizaIconePublicar = this.renderizaIconePublicar.bind(this);
    }

    renderizaIconePublicar(item) {
        const {
            numeroEdicao, status, loading
        } = item;
        const _publicado = status === "Publicada",
            _functionBtn = _publicado ? "desativar" : "publicar",
            _classIcon = _publicado ? `far fa-eye-slash` : `far fa-eye`,
            _textTooltip = _publicado ? "desativar edição" : "publicar edição";
        return (
            <div className="row no-gutters">
                <div className="col-12 icones" id={`Tooltip-${numeroEdicao}`}>
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-primary" role="status" />
                    ) : (
                        <button onClick={() => this.props.confirmaStatusPublicacao(numeroEdicao, _functionBtn)}>
                            <i className={`${_classIcon}`}></i>
                        </button>
                    )}
                    <UncontrolledTooltip placement="top" target={`Tooltip-${numeroEdicao}`}>
                        {_textTooltip}
                    </UncontrolledTooltip>
                </div>
            </div>
        )
    }
    render() {
        const {
            numeroEdicao, dtPublicacao, dtModificacao, usuario, status, periodico
        } = this.props.item;

        const { permissaoEdicao } = this.props;

        return (
            <div className="row lista-edicoes">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div onClick={() => this.props.selecionaEdicao(numeroEdicao)} className="col-6 order-1 text-center pointer col-lg-1 order-lg-2 text-lg-center">
                                    <strong><p className="m-0">Edição</p></strong>
                                    <span>{numeroEdicao}</span>
                                </div>
                                <div onClick={() => this.props.selecionaEdicao(numeroEdicao)} className="col-6 order-3 text-center pointer col-lg-2 order-lg-1 text-lg-center mt-4 mt-lg-0">
                                    <ImagemFukyo
                                        className={`img img-capa-edicao`}
                                        src={`${`https://meubs.com.br/assets/hk/${periodico.toLowerCase()}-capas/${periodico.toLowerCase()}-${numeroEdicao}${periodico.toLowerCase() === "tc" ? '-min' : '_optimized'}.jpg`}?v=${Math.random()}`}
                                        alt={`capa-${periodico.toLowerCase()}`} />
                                </div>
                                <div className="col-6 order-2 text-center col-lg-2 order-lg-3 text-lg-center">
                                    <strong><p className="m-0">Dt. edição</p></strong>
                                    <span>{moment(dtPublicacao).format("DD/MM/YY")}</span>
                                </div>
                                <div className="col-lg-2 order-lg-4 text-lg-center  d-none d-lg-block">
                                    <strong><p className="m-0">Dt. modificação</p></strong>
                                    <span>{moment(dtModificacao).format("DD/MM/YY")}</span>
                                </div>
                                <div className="col-lg-2 order-lg-5 text-lg-center  d-none d-lg-block">
                                    <strong><p className="m-0">Usuário</p></strong>
                                    <span>{usuario}</span>
                                </div>
                                <div className="col-6 order-4 text-center col-lg-2  order-lg-6 text-lg-center mt-3 mt-lg-0">
                                    <strong><p className="m-0">Status</p></strong>
                                    <span className={`badge badge-${status === 'Publicada' ?
                                        'success' : 'secondary badge-opacity'}`}>{status}</span>
                                </div>
                                {permissaoEdicao && (
                                    <div className="col-lg-1 order-lg-7 text-lg-center pointer d-none d-lg-block">
                                        {this.renderizaIconePublicar(this.props.item)}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default Editions;